import PrestigeAutomation from "../../model/automation/PrestigeAutomation";
import AutomationView from "./AutomationView";

export default class PrestigeAutomationView extends AutomationView {
    /**
     * @param {string} parentId
     * @param {string} elementId
     * @param {string} headerText 
     * @param {PrestigeAutomation} automation
     */
    constructor(parentId, elementId, headerText, automation) {
        super(parentId, elementId, headerText, automation);
        
        /**
         * @constant
         * @type {PrestigeAutomation}
         */
        this.prestigeAutomation = automation;

        /**
         * @type {number}
         */
        this.displayedElapsedSeconds = -1;
    }

    /**
     * This exists so that prestige automation can inject their own class name.
     * @override
     * @returns {string}
     */
    getProgressElementClassName() {
        return 'automation-progress-panel';
    }

    /**
     * @override
     */
    updateViewContents() {

        const active = this.automation.active;

        if (this.displayedActive !== active) {
            this.displayedActive = active;

            const mainStyleClass = active ? 'automation-button-outer-active' : 'automation-button-outer-not-active';
            this.mainElement.className = mainStyleClass;

            this.descriptionElement.innerHTML = this.getDescription();
        }

        if (active) {
            const percent = this.automation.getActivationPercent();
            if (this.displayedPercent !== percent) {
                this.displayedPercent = percent;
                this.activeProgressElement.style.width = percent + '%';
            }
        }
    }

    /**
     * @override
     * @returns {string}
     */
    getDescription() {
        if (!this.automation.active) {
            return 'Not Active';
        }

        return 'Active';
    }
}